import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import ReactCompareImage from 'react-compare-image';
import { settingsApi } from '@/services/api';

const DEFAULT_BEFORE = 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200';
const DEFAULT_AFTER = 'https://images.pexels.com/photos/29925933/pexels-photo-29925933.jpeg?w=1200';

const BeforeAfterSection = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const [sectionSettings, setSectionSettings] = useState({
    before: DEFAULT_BEFORE,
    after: DEFAULT_AFTER,
    titleEn: '',
    titleAr: '',
  });

  useEffect(() => {
    settingsApi.get().then((res) => {
      const s = res.data;
      setSectionSettings({
        before: s.transformation_before_image || DEFAULT_BEFORE,
        after: s.transformation_after_image || DEFAULT_AFTER,
        titleEn: s.transformation_title_en || '',
        titleAr: s.transformation_title_ar || '',
      });
    }).catch(() => {});
  }, []);

  const displayTitle = isRTL
    ? (sectionSettings.titleAr || t('beforeAfter.title'))
    : (sectionSettings.titleEn || t('beforeAfter.title'));

  return (
    <section data-testid="before-after-section" className="section-padding bg-secondary">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="label-text mb-4 block">{displayTitle}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            {displayTitle}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto"
        >
          <div className="relative">
            <ReactCompareImage
              leftImage={sectionSettings.before}
              rightImage={sectionSettings.after}
              leftImageLabel={t('beforeAfter.before')}
              rightImageLabel={t('beforeAfter.after')}
              sliderLineColor="#ef7f1a"
              sliderLineWidth={3}
              handle={
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center shadow-lg">
                  <div className="flex gap-1">
                    <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[8px] border-r-charcoal" />
                    <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-charcoal" />
                  </div>
                </div>
              }
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
